import { render, staticRenderFns } from "./Lgx264030153955344384.vue?vue&type=template&id=784e206d&"
import script from "./Lgx264030153955344384.vue?vue&type=script&lang=js&"
export * from "./Lgx264030153955344384.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports